/**
 * JSR
 * e_produkt_konfigurator_2025.js
 * JQuery funkce pro stránku produktu e-shopu - konfigurátor
 *
 * @package eshop
 *
 * @author Jiří Chalupný <jchalupny@skit.cz>
 * @copyright (c) 2007-2026 Josef Šmíd
 * @version 2.5.9
 */

$(document).ready(function() 
{
  var root = $( 'input#js_root' ).val(); 
   
  $(window).on('resize', initInfoTool);
  initInfoTool(); 
  
  /*$(window).on('load', function () {
    if (window.matchMedia('(max-width: 576px)').matches && $(window).scrollTop() === 0) {
      const $target = $('#hlavni');
      if ($target.length) {
        $('html, body').animate({
          scrollTop: $target.offset().top
        }, 1200);
      }
    }
  });*/
   
  let previousSluzba = null;
  
  $( ".material_change" ).change( function(e){  
    var id_kat = $( this ).val();
    $( "#kat_desky" ).val( id_kat ); 
    
    $( ".konf_blok" ).removeClass( "hidden" ); 
    var deska_konf_skryt = $( this ).attr( 'deska-konf-skryt' ).split( ',' );
    $.each( deska_konf_skryt, function(index, element) {
      $( "#konf_blok_" + element ).addClass( "hidden" );
    });
    
    if( $( this ).attr( "deska-special" ) === "1" )
    { 
      $( '.mini_konf_special input[type=radio]' ).each(function (index, element) {
        if (jQuery.inArray( id_kat , $(element).attr('data-kategorie').split(',')) !== -1 )
        { 
          $( element ).parent( 'span' ).removeClass( "hidden" ); 
        }
        else
        {
          $( element ).parent( 'span' ).addClass( "hidden" );
        }
      });  
    }
    
    if( previousSluzba !== null )
    {    
      $( "#konf_prvek_" + previousSluzba.attr( "extra_sluzba" ) ).prop('checked', false);
      $( "#konf_prvek_" + previousSluzba.data("zakaz_tloustka") ).parent().removeClass( "hidden" );
      const dekory = previousSluzba.data("zakaz_dekor").split(",");
      dekory.forEach(function (dekor, index) {
        $("#konf_prvek_" + dekor + ", #konf_prvek_zmen_" + dekor).prop("disabled", false).parent().removeClass("zakaz_dekor_disabled");
      });
      
      previousSluzba = null;
    }
     
    if( $( this ).attr( "extra_sluzba" ) )
    {
      const tloustka = $(this).data("zakaz_tloustka");  
      const dekory = $(this).data("zakaz_dekor").split(",");
      $( "#konf_prvek_" + $( this ).attr( "extra_sluzba" ) ).prop('checked', true);
      previousSluzba = $( this );
      
      // 1. Zkontrolovat, jestli radio s ID rovno `tloustka` není vybrán
      const $radioTloustka = $("#konf_prvek_" + tloustka);  
      if ($radioTloustka.prop("checked")) {  
        // Vybrat následující radio za tímto
        const $next = $radioTloustka.closest("label, span, div").next().find("input[type='radio']").first();
        if ($next.length) {
          $next.prop("checked", true);
        }
      }
      
      $("#konf_prvek_" + tloustka).parent().addClass( "hidden" );
      
      // 2. Zkontrolovat, jestli některý radio box s hodnotou z dekory je vybrán
      const anyChecked = dekory.some(function (val) {
        return $("#konf_prvek_" + val).is(":checked");
      });

      if (anyChecked) {
        // Vybrat první nedisabled radio s odpovídající hodnotou
        $('input[name="vyber_10014"]').first().prop("checked", true);
      }
      
      dekory.forEach(function(dekor, index) {
        $("#konf_prvek_" + dekor + ", #konf_prvek_zmen_" + dekor).prop( "disabled", true ).prop( "checked", false ).parent().addClass( "zakaz_dekor_disabled" );
      });
    }
     
    //musím se zachovat, jako by se právě otevřel konfigurátor - načíst dostupnosti, apod.
    if( $( "#konf_vyber_1" ).length > 0 )
    {
      var bez_dost_ceny = true;
      nactiKonfDostupnost( $( ".mini_konf_select:first" ).attr( "data-krok-prefix" ), $( ".mini_konf_select:first" ).attr( "data-krok-prefix" )+"|k2|", $( ".mini_konf_select:first" ).attr( "data-can_objednat" ), $( "#kat_konf" ).val(), "", "", true ); 
      $( "#konf_vyber_1" ).trigger("change");
      bez_dost_ceny = false; 
      $(window).scroll();
    } 
    
    if( $( this ).attr( "deska-special" ) === "1" )
    {
      $( '.mini_konf_special input[type=radio]').attr('checked', false);
      $( '.mini_konf_special input[type=radio]:not(.hidden):not(:disabled)' ).first().attr('checked', true).trigger('change');
    } 
  });
  
  //malý konfigurátor
  var prvni_pruchod = 0;
  $( ".mini_konf_select" ).change( function(e){  
    if( $( this ).attr( "data-poradi" ) === "3" && $( this ).attr(  "data-typ" ) === "1" && $( "#" + $( this ).attr( "id" ) + " input[type='radio']:checked" ).val() === "atyp" && $( "label[for='konf_prvek_atyp'] .extra_pole" ).attr( "data-val" ) === "" ) return false;
    var def = "";
    var def_kosik = "";
    var val = "";
    var krok = "0";
    var bez_desky = false;
    var poradi = $( this ).attr( "data-poradi" ); 
    var vl = $( "label[for='konf_prvek_atyp'] .extra_pole" ).attr( "data-val" );
    var akt_predpocet = $( this ).attr( "data-akt-predpocet" );
    var predpocet_data = [];
    
    if( prvni_pruchod === 0 ) akt_predpocet = "1";
    
    $( ".koupit_stul" ).addClass( "loading" ); 
    if( $( "#konf_vyber_3 input[type='radio']:checked" ).val() === "bez_desky" ) bez_desky = true;//musím zde mít prvek napevno, abych se na něj vždy podíval, jestli nemám výběr bez desky
    else 
    {
      $( ".konf_bez_desky" ).removeClass( "konf_bez_desky" );
      $( ".zobrazit_bez_desky" ).attr( "data", "101,102,105" );
    } 
     
      $( ".mini_konf_select" ).each(function ( index )
      {  
        if( vynechatVyber( $(this).attr("data-vyber") ) ) return true;
        if( bez_desky && $( this ).attr( "data-krok" ) !== "0" ) return false;
        if( krok !== $( this ).attr( "data-krok" )  )
        {
          if (def.slice(-1) !== ":")
          {
            def += ":";
            def_kosik += ":";
          }
          krok = $( this ).attr( "data-krok" );
        }
        var prefix = $( this ).attr( "data-krok-prefix" );
        if( prefix !== false && typeof prefix !== 'undefined' && $( this ).attr(  "data-typ" ) !== "3" )
        {
          def += prefix;
          def_kosik += prefix;
        } 

        var konf_blok = "#" + $( this ).attr( "id" ); 
        if( parseInt( $( this ).attr( "data-poradi" ) ) < 5 ) konf_blok = "#konf_blok_" + $( this ).attr( "data-vyber" ) + " " + konf_blok;
        
        if( $( this ).attr(  "data-typ" ) === "1" ) 
        { 
          val = $( konf_blok + " input[type='radio']:checked" ).length ? $( konf_blok + " input[type='radio']:checked" ).val() : '';
          if( val !== '' )
          {
            def += "_" + val; 
            def_kosik += "_" + val; 
          }  
        }
        else if( $( this ).attr(  "data-typ" ) === "3" ) 
        { 
          val = $( konf_blok + " input[type='radio']:checked" ).length ? $( konf_blok + " input[type='radio']:checked" ).val() : '';
          def += "" + val; 
          def_kosik += "" + val; 
        }
        else if( $( this ).attr(  "data-typ" ) === "2" )
        {  
          if( $( konf_blok + " input[type='checkbox']").is(':checked') )
          { 
            if( $( this ).attr(  "data-prohodit" ) === "1" )
            { 
              if( $( konf_blok + " select" ).length > 0 )
              {
                if( $( konf_blok + " select" ).val() === "" )
                {
                  $( konf_blok + " input[type='checkbox']" ).attr( "disabled", true ); 
                  $( konf_blok + " select" ).focus().css( "background-color", "rgba(255, 0, 0, 0.8)" );
                  $( ".koupit_stul" ).attr( "disabled", true ); 
                  return false;
                }
                else
                {
                  def_kosik += $( konf_blok + " select" ).val();
                  $( konf_blok + " select" ).css("background-color", ""); 
                  $( ".koupit_stul" ).attr( "disabled", false );
                  $( konf_blok + " input[type='checkbox']" ).attr( "disabled", false ); 
                }
                def += $(konf_blok + " input[type='checkbox']:checked").val();
                def_kosik += "-" + $(konf_blok + " input[type='checkbox']:checked").val() + ";true2";
              }
            }
            else
            {
              def += $( konf_blok + " input[type='checkbox']:checked" ).val();
              def_kosik += $( konf_blok + " input[type='checkbox']:checked" ).val();
              if( $( konf_blok + " select" ).length > 0 )
              {
                if( $( konf_blok + " select" ).val() === "" )
                {
                  $( konf_blok + " input[type='checkbox']" ).attr( "disabled", true ); 
                  $( konf_blok + " select" ).focus().css( "background-color", "rgba(255, 0, 0, 0.8)" );
                  $( ".koupit_stul" ).attr( "disabled", true ); 
                  return false;
                }
                else
                {
                  def_kosik += "-" + $( konf_blok + " select" ).val() + ";true";
                  $( konf_blok + " select" ).css("background-color", ""); 
                  $( ".koupit_stul" ).attr( "disabled", false );
                  $( konf_blok + " input[type='checkbox']" ).attr( "disabled", false ); 
                }
              }
            }
          } 
          else 
          { 
            def = def.slice(0,-1);
            def_kosik = def_kosik.slice(0,-1);
          }
        }
        else 
        {   
          val = $(this).val() || '';
          if( val !== '' )
          {
            def += "_" + val; 
            def_kosik += "_" + val;  
          }
        }
          
        if( index === $( ".mini_konf_select" ).length - 1 || bez_desky )//$( ".mini_konf_select" ).length === parseInt( $( this ).attr( "data-poradi" ) ) nefunguje, nyní mám všechny výběry kvůli přepínání materiálu, chci volat při posledním průchodu
        {  
          if( bez_dost_ceny !== true ) 
          {
            nactiCenuDostupnostImg( def_kosik, $( "#kat_konf" ).val(), window.slider_bx, ( def.indexOf( "atyp" ) > 0 ? vl : "" ), prvni_pruchod );//poslední select -> volat dotaz na dostupnost, cenu, obrázek  
          }
        }
        else if( poradi <= $( this ).attr( "data-poradi" ) )
        { 
          //nastavit viditelnost položek, v případě nevhodné kombinace označit následující selecty červeně, vypsat chybovou hlášku, ukončit cyklus  
          var dalsi_krok = nactiDalsiKrokKonf( parseInt( $( this ).attr( "data-poradi" ) ) );
          nactiKonfDostupnost( dalsi_krok, def, $( this ).attr( "data-can_objednat" ), $( "#kat_konf" ).val(), $( "#kat_desky" ).val(), ( def.indexOf( "atyp" ) > 0 ? vl : "" ) );  
        } 
        
        if( akt_predpocet === "1" )
        {
          if( $( this ).attr( "data-predpocet" ) === "1" ) 
          { 
            ///nactiKonfPredpocet( dalsi_krok, val, $( "#kat_konf" ).val(), $( "#kat_desky" ).val(), $( this ).attr( "data-vyber" ), $( this ).attr( "data-krok" ) );
            predpocet_data.push({ aktualni_kod: val, kategorie: $( "#kat_konf" ).val(), kat_desky: $( "#kat_desky" ).val(), vyber: $( this ).attr( "data-vyber" ), krok: $( this ).attr( "data-krok" ) });
            $( ".mini_konf_select[data-vyber='" + $( this ).attr( "data-vyber" ) + "'] .extra_pole_cena" ).html( "" ); 
          }
        }
      }); 
    //zde projít všechny selecty, jestli některý nemá vybrán option který je disabled - pokud najdu vypsat chybu a označit daný select 
    var chyba = 0;
    $( ".mini_konf_select" ).each(function ()
    { 
      if( vynechatVyber( $(this).attr("data-vyber") ) ) return true;
      if( $( this ).find( ":selected:disabled" ).length > 0 && !bez_desky )
      {
        $( "#mini_konfigurator_chyba" ).removeClass( "hidden" );
        $( ".koupit_stul" ).attr( "disabled", true );
        $( this ).parent().css( "background-color", "rgba(255, 0, 0, 0.1)" );
        chyba = 1;
      }
      else if( ( $( this ).find( ":checked:disabled" ).length > 0 || ( $( this ).find( "input[type=radio]" ).length > 0 && !$( this ).find( "input[type=radio]:checked" ).length ) ) && !bez_desky )
      { 
        $( "#mini_konfigurator_chyba" ).removeClass( "hidden" );
        $( ".koupit_stul" ).attr( "disabled", true );
        if( $( this ).attr(  "data-typ" ) !== "2" )
          $( this ).parent().css( "background-color", "rgba(255, 0, 0, 0.1)" );
        chyba = 1;
      }
      else
      {
        $( this ).parent().css("background-color", ""); 
        if( bez_desky && ( $( this ).attr( "data-krok" ) !== "0" ) )
        {
          $( this ).not( "#konf_vyber_3" ).parent().addClass( "konf_bez_desky" );
          $( ".zobrazit_bez_desky" ).attr( "data", "101,104" );
          $( ".sluzby, .material" ).addClass( "konf_bez_desky" );
          $( ".extra_pole_cena" ).html( "" ); 
        }
      } 
    });
    //u nedostupných dekorů chci vypsat info navíc
    //$( "#zmenit_vyber_dekor label" ).attr( "title", "" );
    $( "#zmenit_vyber_dekor label i" ).hide();
    //$( "#zmenit_vyber_dekor .hidden_sedy label" ).attr( "title", $( "#zmenit_vyber_dekor" ).attr( "data-hidden" ) );
    $( "#zmenit_vyber_dekor .hidden_sedy:not(.zakaz_dekor_disabled) label i.dekor_info_rozmer" ).show();
    $( "#zmenit_vyber_dekor .zakaz_dekor_disabled label i.dekor_info_oblina" ).show();

    $('#konf_vyber_4 input[type="radio"]').each(function () {
      const $img = $('label[for="' + this.id + '"] img');

      if (this.disabled) {
        //dekor zakázaný kvůli vybranému materiálu (bez obliny) vs. klasicky nedostupný dekor
        const txt = $(this).parent().hasClass( "zakaz_dekor_disabled" )
          ? $("#zmenit_vyber_dekor").data("disabledOblina")
          : $("#zmenit_vyber_dekor").data("disabled");
        $img.attr('title', $img.attr('alt') + '<br><i>' + txt + '</i>');
      } else {
        $img.attr('title', $img.attr('alt'));
      }
    });
    
    initMobileSelect();//potřebuji znovu načíst upravené selecty pro menší rozlišení
    
    if( chyba === 0 )
    {
      $( "#mini_konfigurator_chyba" ).addClass( "hidden" );
      $( "#mini_konf_produkty" ).val( def_kosik.replaceAll( ":", "|" ) );
      $( ".koupit_stul" )./*attr( "onclick", "window.location='" + $( ".koupit_stul" ).attr( "url-def" ).replace( "replace", def ) + ( bez_dost_ceny !== true ? "?min=1" : "?min=0" ) + "'" ).*/attr( "disabled", false );
      //$( ".koupit_konfigurator" ).attr( "href", $( ".koupit_konfigurator" ).attr( "url-def" ).replace( "replace", def ) + ( bez_dost_ceny !== true ? "?min=1" : "?min=0" ) ).attr( "disabled", false );
      predpocet_data.forEach(function(item) {
          nactiKonfPredpocet( def_kosik.replaceAll( ":", "|" ), item );
      });
    } 
    $( ".koupit_stul" ).removeClass( "loading" );
    prvni_pruchod = 1;
  });
   
  //změna povrchu
  $('#zmenit_vyber').click(function ()
  { 
    //$('body').css('overflow', 'hidden');
    //$(window).scrollTop( 0 );
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();  
    var slider_bx_povrch = null;
    $("#zmenit_vyber_dekor").dialog({
      resizable: true,
      width: ( windowWidth <= 600 ? windowWidth - 50 : ( windowWidth >= 1200 ? "1150" : "90%" ) ),
      height: ( windowHeight <= 920 ? windowHeight - 80 : "920" ),
      modal: true,
      closeText: "",
      dialogClass: "dialog_konfigurator",
      open: function() { 
          initMobileSelect( 1 );
        
          $( "#zmenit_vyber_submit, #zmenit_vyber_submit_2" ).click(function(){ 
            $("#zmenit_vyber_dekor").dialog("close");
          }); 
 
          if( $( "#zmenit_vyber_dekor input[type='radio']:checked" ).val() )
          {
            slider_bx_povrch = $( '#eshop_obrazek_slider_span_' + $( "#zmenit_vyber_dekor input[type='radio']:checked" ).val() ).bxSlider({
              mode: 'fade',
              speed: 0,
              infiniteLoop: true, 
              controls: true,
              touchEnabled: false,//swipe nefunguje na iOs a ve chrome blbne - nefungují eventy
              keyboardEnabled: true 
              /*onSlideBefore: function($slideElement, oldIndex, newIndex){
          var $lazy = $slideElement.find(".lazy")
          var $load = $lazy.attr("data-src");
          $('.lazy img').load(function(){
              $lazy.attr("src",$load).removeClass("lazy");
          });
      },*/
            }); 
          }
        
        $( ".prvky_dekoru input[type='radio']" ).change( function(){  
          if( slider_bx_povrch ) slider_bx_povrch.destroySlider();
          $( ".popisy_dekoru span, .fotky_dekoru div.konf_prvek_zmen_fotky" ).addClass( "hidden" );
          $( "#konf_prvek_zmen_popis_" + $( this ).val() ).removeClass( "hidden" );
          $( "#konf_prvek_zmen_fotky_" + $( this ).val() ).removeClass( "hidden" );
          slider_bx_povrch = $( '#eshop_obrazek_slider_span_' + $( this ).val() ).bxSlider({
            mode: 'fade',
            speed: 0,
            infiniteLoop: true, 
            controls: true,
            touchEnabled: false,//swipe nefunguje na iOs a ve chrome blbne - nefungují eventy
            keyboardEnabled: true 
          }); 
        });
        
        $( "#konf_prvek_zmen_" + $( "#konf_vyber_4 input[name=vyber_10014]:checked" ).val() ).prop('checked', true).change();
        openDialogScroll();
      }, 
      close: function() {
        closeDialogScroll();
      },
      beforeClose: function () {
        //$('body').css('overflow', '');
        if( slider_bx_povrch ) slider_bx_povrch.destroySlider();
      },
      buttons: {
        "Zavřít": function () {
          //$('body').css('overflow', '');
          if( slider_bx_povrch ) slider_bx_povrch.destroySlider();
          $(this).dialog("close");
        }
      }
    });
    return false;
  });
  //přendáno mimo dialog open, abych mohl volat i z jiného místa
  $( "#zmenit_vyber_submit, #zmenit_vyber_submit_2" ).click(function(){  
    var vybran = $( "#zmenit_vyber_dekor input[type='radio']:checked" );  
    $( "#konf_prvek_" + vybran.attr( "value" ) ).click(); 
  });
  
  //velikost atypu   
  $('#konf_prvek_atyp').click(function ()
  { 
    var windowWidth = $(window).width();
    $("#zmena_velikosti").dialog({
      resizable: true,
      width: ( windowWidth <= 700 ? windowWidth - 50 : "700px" ),
      modal: true,
      closeText: "",
      dialogClass: "dialog_konfigurator",
      open: function() {
        /*$( "#zmena_velikosti #width" ).click();
        $("#zmena_velikosti input[type='number']").click(function ()
        {
          $(this).addClass('zmena_velikosti_input');
          $(this).parent('div').children('.zmena_velikosti_range').slideDown("slow", function () {});
          $(this).parent('div').children('.zmena_velikosti_range').show();
        });*/
        $( "#zmenit_atyp" ).click(function(){ 
          $("#zmena_velikosti").dialog("close");
        });
        $( "#zmena_velikosti #width, #zmena_velikosti #height" ).change(function() {
          if( parseInt( $( this ).attr( "min" ) ) > parseInt( $( this ).val() ) || $( this ).val() === "" ) $( this ).val( $( this ).attr( "min" ) );
          if( parseInt( $( this ).attr( "max" ) ) < parseInt( $( this ).val() ) || $( this ).val() === "" ) $( this ).val( $( this ).attr( "max" ) );
          $( this ).val( ziskejCeleCislo( $( this ).val() ) );
        });
        openDialogScroll();
      }, 
      close: function() {
        //var width = $("#zmena_velikosti #width").val().replace(/\D/g, '');
        //var height = $("#zmena_velikosti #height").val().replace(/\D/g, '');
        var width = ziskejCeleCislo($("#zmena_velikosti #width").val());
        var height = ziskejCeleCislo($("#zmena_velikosti #height").val());

        $("label[for='konf_prvek_atyp'] .nazev").contents().filter(function () {
          return this.nodeType === 3; // textový uzel
        }).first().replaceWith($("label[for='konf_prvek_atyp'] .extra_pole").attr("data-text") + " (" + width + "x" + height + ")");
        $("label[for='konf_prvek_atyp'] .extra_pole").html($("label[for='konf_prvek_atyp'] .extra_pole").attr("data-zmenit"));
        $("label[for='konf_prvek_atyp'] .extra_pole").attr("data-val", width + "x" + height);
        $("#mini_konf_rozmer").val(width + "x" + height + " cm");

        $("label[for='konf_prvek_atyp']").change();
        closeDialogScroll();
      },
      beforeClose: function () {
        //$('body').css('overflow', ''); 
        //nastavování a kontrola hodnot přesunuta do close - zde nereagovalo na zavření pomocí ESC
      },
      buttons: {
        "Zavřít": function () {
          //$('body').css('overflow', '');
          
          $(this).dialog("close");
        }
      }
    });
  });
  
  //prvotní načtení po otevření stránky
  if( $( "#konf_vyber_1" ).length > 0 )
  {
    var bez_dost_ceny = true;
    if( $( "#tri_d" ).val() === "1" || $( "#tri_d" ).val() === "2" ) bez_dost_ceny = false;//v tři D konfigurátoru chci načítat rovnou obrázek
    nactiKonfDostupnost( $( ".mini_konf_select:first" ).attr( "data-krok-prefix" ), $( ".mini_konf_select:first" ).attr( "data-krok-prefix" )+"|k2|", $( ".mini_konf_select:first" ).attr( "data-can_objednat" ), $( "#kat_konf" ).val(), "", "", true ); 
    $( "#konf_vyber_1" ).trigger("change");
    bez_dost_ceny = false;
    //produkt bez desky (viz e_produkt.php) - konfigurátor se nejdřív načte s deskou, aby se skryly volby nedostupné pro podnož i desku, a teprve pak se přepne na bez desky jako při kliknutí
    if( $( "#konf_prvek_bez_desky[data-vychozi='1']" ).length > 0 ) $( "#konf_prvek_bez_desky" ).prop( "checked", true ).trigger( "change" );
    $(window).scroll();
  }

  $( ".konf_blok .nadpis_h3 span" ).click( function(){   
    $( "#" + $( this ).attr( "data" ) ).click(); 
  });
    
  $( "#open_prodejny_desky_vybrat" ).click(function(){ 
    if( $( "#open_prodejny_form input[name=deska_prodejna]" ).is(':checked') )
    {
      var deska = $( "#open_prodejny_form input[name=deska_prodejna]:checked" ).val().split("_"); 
      $( "#konf_prvek_" + deska[1] ).click();
      $( "#konf_prvek_" + deska[2] ).click();
      $( "#konf_prvek_" + deska[3] ).click(); 
      //$( "#zmenit_vyber_submit" ).click();
    }
    $("#open_prodejny_form").dialog("close");
  });
  
  /*var slider_bx_sluzby = null;
  $( '.sluzba_zjisti_vice' ).click(function()
  {
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    $( 'div#sluzba_popis_' + $( this ).attr( "data-id" ) ).dialog({
      width: ( windowWidth <= 600 ? windowWidth - 50 : "60%" ),  
      height: ( windowWidth <= 600 ? windowHeight*0.9 : windowHeight*0.7 ),
      modal: true,
      resizable: true,
      dialogClass: "dialog_web", 
      beforeClose: function () {
        if (slider_bx_sluzby)
            slider_bx_sluzby.destroySlider();
      },
      buttons: {
        Close: function() { 
          $( this ).dialog( "close" );
        }
      }
    });

    if( $('#eshop_obrazek_slider_sluzba_' + $( this ).attr( "data-id" )).length > 0 )
    {
      slider_bx_sluzby = $('#eshop_obrazek_slider_sluzba_' + $( this ).attr( "data-id" )).bxSlider({
        mode: 'fade',
        speed: 0,
        infiniteLoop: true,
        controls: true,
        touchEnabled: false
      });
      slider_bx_sluzby.reloadSlider();
    }
    return false;
  });*/
  
  $( '#materialy_popis' ).click(function()
  {
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    $( 'div#materialy_popis_dialog' ).dialog({
      width: ( windowWidth <= 550 ? windowWidth - 50 : "550px" ),  
      height: ( windowWidth <= 600 ? windowHeight*0.9 : windowHeight*0.8 ),
      modal: true,
      resizable: true,
      dialogClass: "dialog_konfigurator", 
      open: function() {
        openDialogScroll();
      },
      close: function() {
        closeDialogScroll();
      },
      beforeClose: function () {
   
      },
      buttons: {
        Close: function() { 
          $( this ).dialog( "close" );
        }
      }
    });  
    
    return false;
  });
  
  $( '#podnoze_popis' ).click(function()
  {
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    $( 'div#podnoze_popis_dialog' ).dialog({
      width: ( windowWidth <= 550 ? windowWidth - 50 : "550px" ),  
      height: ( windowWidth <= 600 ? windowHeight*0.9 : windowHeight*0.8 ),
      modal: true,
      resizable: true,
      dialogClass: "dialog_konfigurator", 
      open: function() {
        openDialogScroll();
      },
      close: function() {
        closeDialogScroll();
      },
      beforeClose: function () {
   
      },
      buttons: {
        Close: function() { 
          $( this ).dialog( "close" );
        }
      }
    });  
    
    return false;
  });
   
  //initMobileSelect(); přidám na konec procházení konfigurátoru
  $(window).on('resize', initMobileSelect);
    
  
});

function ziskejCeleCislo(hodnota) {
    var m = hodnota.match(/\d+/);
    return m ? m[0] : '';
}

function initMobileSelect( extra=0 ) {
  let typ = ".radio_hodnoty_img";//.radio_hodnoty, 
  let typClass = "mobile-dropdown-wrapper-hodnoty";
  
  if( extra === 1 )
  {
    typ = ".prvky_dekoru";
    typClass = "mobile-dropdown-wrapper-dekor";
  }
  // zničíme staré wrappery
  $('.' + typClass).remove();
  $(typ).show().each(function () {
    $(this).removeData('mobile-select-init');
  });

  if (window.matchMedia('(max-width: 991px)').matches) {
    $(typ).each(function () {
      const $container = $(this);
      if ($container.data('mobile-select-init')) return;

      const isImageType = $container.hasClass('radio_hodnoty_img');
      const $wrapper = $('<div class="mobile-dropdown-wrapper ' + typClass + '"></div>');
      const $selected = $('<div class="mobile-selected"></div>');
      const $optionsWrapper = $('<div class="mobile-options"></div>');

      $container.find('span').each(function () {
        const $span = $(this);
        
        if ($span.hasClass('hidden')) return; // přeskočíme skryté volby
        
        const $radio = $span.find('input[type="radio"]');
        const $optionDiv = $('<div class="mobile-option"></div>');
        const $label = $span.find('label');

        // --- Rozdíl mezi textovým a obrázkovým typem ---
        if (isImageType) {
          const $img = $label.find('img');
          const title = $img.attr('title') || $radio.data('nazev') || $radio.val();
          const src = $img.attr('src');
          $optionDiv.html(`<img src="${src}" alt="${title}" title="${title}"><span>${title}</span>`);
        } else {
          $optionDiv.html($label.html());
        }
        
        if ($optionDiv.find('img').length) {
          $wrapper.addClass('has-image');
        }

        // --- Disabled / readonly ---
        if ($radio.is(':disabled') || $radio.is('[readonly]')) {
          $optionDiv.addClass('disabled');
          return $optionsWrapper.append($optionDiv);
        }

        // --- Aktuálně vybraný ---
        if ($radio.is(':checked')) {
          let $content;
          if (isImageType) {
            const $img = $label.find('img');
            const title = $img.attr('title') || $radio.data('nazev') || $radio.val();
            const src = $img.attr('src');
            $content = `<img src="${src}" alt="${title}" title="${title}"><span>${title}</span>`;
          } else {
            const $labelClone = $label.clone();
            $labelClone.find('.extra_pole').remove();
            $content = $labelClone.html();
          }
          $selected.html($content);
          $optionDiv.addClass('selected');
        }

        // --- Kliknutí na volbu ---
        $optionDiv.on('click', function (e) {
          e.stopPropagation();
          if ($optionDiv.hasClass('disabled')) return;

          $radio.prop('checked', true).trigger('change').trigger('click');
          $optionsWrapper.find('.mobile-option').removeClass('selected');
          $optionDiv.addClass('selected');

          let $content;
          if (isImageType) {
            const $img = $label.find('img');
            const title = $img.attr('title') || $radio.data('nazev') || $radio.val();
            const src = $img.attr('src');
            $content = `<img src="${src}" alt="${title}" title="${title}"><span>${title}</span>`;
          } else {
            const $labelCloneClick = $label.clone();
            $labelCloneClick.find('.extra_pole').remove();
            $content = $labelCloneClick.html();
          }
          $selected.html($content);

          $optionsWrapper.slideUp(150);
          $selected.removeClass('open_select');
        });

        $optionsWrapper.append($optionDiv);
      });

      // --- Otevření / zavření dropdownu ---
      $selected.on('click', function (e) {
        e.stopPropagation();
        $('.mobile-options').not($optionsWrapper).slideUp(150);
        $('.mobile-selected').not($selected).removeClass('open_select');
        $optionsWrapper.slideToggle(150);
        $selected.toggleClass('open_select');
      });
      
      // Sleduj scrollování okna
      $(window).on('scroll', function () {
        $('.mobile-dropdown-wrapper .mobile-options:visible').each(function () {
          const $options = $(this);
          const $wrapper = $options.closest('.mobile-dropdown-wrapper');
          const wrapperTop = $wrapper.offset().top;
          const wrapperBottom = wrapperTop + $wrapper.outerHeight();
          const windowTop = $(window).scrollTop();
          const windowBottom = windowTop + $(window).height();

          // Pokud wrapper není v zobrazené části okna, zavři select
          if (wrapperBottom < windowTop || wrapperTop > windowBottom -250) {
            $options.slideUp(150);
            $wrapper.find('.mobile-selected').removeClass('open_select');
          }
        });
      });

      $wrapper.append($selected).append($optionsWrapper);
      $container.hide().after($wrapper);
      $container.data('mobile-select-init', true);
    });

    // zavřít klikem mimo
    $(document).off('click.mobileSelect').on('click.mobileSelect', function (e) {
      if (!$(e.target).closest('.mobile-dropdown-wrapper').length) {
        $('.mobile-options').slideUp(150);
        $('.mobile-selected').removeClass('open_select');
      }
    });

  } else {
    // zpět na desktop
    $('.mobile-dropdown-wrapper').remove();
    $(typ).show().each(function () {
      $(this).removeData('mobile-select-init');
    });
  }
}



//výběry které nejsou relevatní pro daný materiál chci přeskočit aby se nezpracovávaly
function vynechatVyber( vyber_id )
{
  if ( $('input.material_change:checked').attr('deska-konf-skryt') === undefined ) return false;
  
  var deska_konf_skryt = $( 'input.material_change:checked' ).attr( "deska-konf-skryt" ).split( "," );
  
  if( jQuery.inArray( vyber_id, deska_konf_skryt ) !== -1 ) return true;
  
  return false;
}

//pro prvotní načtení poslat jako poradi 0
function nactiDalsiKrokKonf( poradi )
{
  var def = "";
  var krok = "0";
  var dalsi_poradi = poradi+1;
  $( ".mini_konf_select" ).each(function ()
  {  
    if( vynechatVyber( $(this).attr("data-vyber") ) ) return true;
    
    if( $( this ).attr(  "data-typ" ) === "2" ) 
    {
      $( this ).find( "input[type=checkbox]" ).attr( "disabled", false ).parent().removeClass( "hidden_sedy" );
      return true;
    }
    if( krok !== $( this ).attr( "data-krok" ) )
    {
      def = "";
      krok = $( this ).attr( "data-krok" );
    }
    var prefix = $( this ).attr( "data-krok-prefix" );
    if( prefix !== false && typeof prefix !== 'undefined' )
    {
      def += prefix;
    } 
    if( dalsi_poradi === parseInt( $( this ).attr( "data-poradi" ) ) ) 
    {  
      $( this ).find( "option" ).attr( "disabled", true ).hide();
      $( this ).find( "input[type=radio]" ).not( "input[value=bez_desky]" ).attr( "disabled", true );/*.parent().hide();*/
      $( "#zmenit_vyber_dekor" ).find( "input[type=radio]" ).attr( "disabled", true ).parent().addClass( "hidden_sedy" );//musím zde mít navíc, jelikož je výběr v dialogu a UI dialog přesune kod jinam
      return false;
    }
    
    if( $( this ).attr(  "data-typ" ) === "1" ) def += "_" + $( "#konf_blok_" + $(this).attr("data-vyber") + " #" + $( this ).attr( "id" ) + " input[type='radio']:checked" ).val();
    else if( $( this ).attr(  "data-typ" ) === "2" || $( this ).attr(  "data-typ" ) === "3" ) def += "" + $( this ).val();
    else def += "_" + $( this ).val(); 
  }); 
  return def;
}
//skryt posilat jen při prvnotním načtení - aby se skryly barvy noh, které nejsou potřeba
function nactiKonfDostupnost( kod_produktu, vsechny_kody, can_objednat, kategorie, kat_desky, vl, skryt=false )//vl
{ 
  if( kod_produktu === "" || kod_produktu === null ) return;
   
  $.ajax({
    url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
    type: "GET",
    dataType: "html",
    async: false,
    cache: false,

    data: { kod_produktu: kod_produktu, typ: 1, vsechny_kody: vsechny_kody.replaceAll( ":", "|" ), can_objednat: can_objednat, kategorie: kategorie, kat_desky: kat_desky, vl: vl },
    success: function (aData) 
    { 
      if (aData)
      { 
        var result = JSON.parse(aData);
        $.each( result.activate, function (key, value) {
          if( !$( "#konf_prvek_" + value ).parent().hasClass( "zakaz_dekor_disabled" ) )//dekor zakázaný materiálem (bez obliny) nechat neaktivní
            $( "#konf_prvek_" + value ).attr( "disabled", false ).parent();//.show();
          if( !$( "#konf_prvek_zmen_" + value ).parent().hasClass( "zakaz_dekor_disabled" ) )
            $( "#konf_prvek_zmen_" + value ).attr( "disabled", false ).parent().removeClass( "hidden_sedy" );
        });
        $.each( result.naobjednani, function (key, value) {
          if( !$( "#konf_prvek_" + value ).parent().hasClass( "zakaz_dekor_disabled" ) )//dekor zakázaný materiálem (bez obliny) nechat neaktivní
            $( "#konf_prvek_" + value ).attr( "disabled", false ).parent();//.show();
          if( !$( "#konf_prvek_zmen_" + value ).parent().hasClass( "zakaz_dekor_disabled" ) )
            $( "#konf_prvek_zmen_" + value ).attr( "disabled", false ).parent().removeClass( "hidden_sedy" );
        });
        
          $.each( result.skryt, function (key, value) {
            if( skryt === true )
            { 
              $( "#konf_prvek_" + value ).parent().remove();
              $( "#konf_prvek_zmen_" + value ).parent().remove();
            }
            else if( $( "#konf_vyber_1000 #konf_prvek_" + value ).length > 0 )
            {
              $( "#konf_prvek_" + value ).attr( "disabled", true ).prop('checked', false).parent().addClass( "hidden_sedy" );
            }
          }); 
      }
    } 
  });
}

function nactiKonfPredpocet( kod_produktu, item )
{
  if( kod_produktu === "" || kod_produktu === null ) return;
  $.ajax({
    url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
    type: "GET",
    dataType: "html",
    async: false,
    cache: false,

    data: { kod_produktu: kod_produktu, typ: 7, aktual: item.aktualni_kod, kategorie: item.kategorie, kat_desky: item.kat_desky, krok: item.krok, vyber: item.vyber },
    success: function (aData) 
    { 
      $( ".mini_konf_select[data-vyber='" + item.vyber + "'] .extra_pole_cena" ).html( "" );
      var result = JSON.parse(aData);
      if ( result )
      {   
        $.each( result, function (key, value) {  
          $( "label[for='konf_prvek_" + key + "'] .extra_pole_cena" ).html( value ); 
        });
      }
    }
  });
}

function nactiCenuDostupnostImg( vsechny_kody, kategorie, slider_bx, vl, prvni_pruchod=0 )
{
  $.ajax({
      url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
      type: "GET",
      dataType: "html",
      async: false,
      cache: false,
      data: { kod_produktu: vsechny_kody, typ: 11, kategorie: kategorie, vl: vl, tri_d: $( "#tri_d" ).val() },
      success: function (aData) {
        var sklad_class = '';
        var cena = '';
        var result = JSON.parse(aData);
        var cena_nej30 = '';
        
        //$( ".eshop_udaje_usetrite" ).html( "" ).hide();
        if( prvni_pruchod === 0 && $( ".cena_nej30" ).length > 0 ) cena_nej30 = '<div class="cena_nej30">' + $( ".cena_nej30" ).html() + '</div>';
//        if( result.cena_bez_akce !== "" && $( "#js_web_lang_zkr" ).val() !== "cz" ){ cena = "<del>" + result.cena_bez_akce + "</del>"; /*$( ".eshop_udaje_usetrite" ).html( result.usetrite ).show();*/ }
//        else if( result.cena_bez_akce !== "" && $( "#js_web_lang_zkr" ).val() === "cz" ) { cena = "<del class='hidden'>" + result.cena_bez_akce + "</del>"; }
        var s_dph = "<i>" + $( "#cena" ).attr( "data-s" ) + "</i>";
        $( "#cena" ).html( "<span>" + result.cena + s_dph + "</span>" + cena + "<i>" + result.cena_bez_dph + "</i>" + cena_nej30 );
        //$( "#cena_viewport" ).html( "<span>" + result.cena + "</span>" );
        $( "#z_cena" ).val( result.z_cena );
        
        if (result.sklad > 0)
          sklad_class = 'dost0';
        else if( result.dodani_mnozstvi > 0 )
          sklad_class = 'dost20';
        else
          sklad_class = 'dost99';
        $( ".price .dostupnost, .dostupnost_central" ).removeClass( "dost0" ).removeClass( "dost7" ).removeClass( "dost20" ).removeClass( "dost30" ).removeClass( "dost99" );
        $( ".price .dostupnost, .dostupnost_central" ).addClass( sklad_class ).html( result.text );
        
//        $( ".slider_u_produktu" ).attr( "src", result.obrazek ).css( "z-index", "0" ).css( "display", "none" ).attr( "aria-hidden", "true" );
//        $( ".slider_u_produktu:first img" ).attr( "src", result.obrazek ).css( "max-width", "90%" ).css( "max-height", "90%" );
//        $( ".slider_u_produktu:first" ).css( "z-index", "50" ).css( "display", "table" ).attr( "aria-hidden", "false" );
        $( ".slider_u_produktu:first img" ).attr( "src", result.obrazek );
        $( ".fotogalerie .fotka_0 img" ).attr( "src", result.obrazek );
        $( ".fotogalerie .fotka_0 a" ).attr( "href", result.obrazek );
        $( ".slider_u_produktu:first img" ).addClass( "generovany_stul" );
        refreshGalerie( "produkt" );
        //slider_bx.reloadSlider();
        if (slider_bx) slider_bx.goToSlide( 0 );
      }
    }); 
}

function initInfoTool() {
  const $targets = $(".right-column-konf");

  if (window.matchMedia('(min-width: 992px)').matches) {
    // inicializuj jen pokud tooltip ještě není vytvořený
    $targets.each(function () {
      const $el = $(this);
      if (!$el.data('ui-tooltip')) {
        $el.tooltip({
          track: false, // tooltip nesleduje kurzor
          show: {effect: "fadeIn", duration: 200},
          hide: {effect: "fadeOut", duration: 200},
          position: {my: "center bottom-2", at: "center top"},
          tooltipClass: "konf-tooltip",
          content: function() {
              return $(this).attr('title');
          }
        });
      }
    });
  } else {
    // znič jen pokud tooltip existuje
    $targets.each(function () {
      const $el = $(this);
      if ($el.data('ui-tooltip')) {
        $el.tooltip('destroy');
      }
    });
  }
}